import type { TradeLogicRegistrySchemaFieldDto } from '../registry';
import SchemaFieldInput from './SchemaFieldInput';

interface SchemaFieldsEditorProps {
    fields: TradeLogicRegistrySchemaFieldDto[];
    title: string;
    values: Record<string, string>;
    disabled?: boolean;
    onValuesChange: (values: Record<string, string>) => void;
}

const SchemaFieldsEditor = ({ disabled = false, fields, title, values, onValuesChange }: SchemaFieldsEditorProps) => (
    <div className="mt-4 rounded-md border border-zinc-800 bg-zinc-950/40 p-3">
        <div className="mb-3 text-xs font-semibold uppercase tracking-wide text-zinc-500">{title}</div>
        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            {fields.map((field) => (
                <SchemaFieldInput
                    disabled={disabled}
                    field={field}
                    key={field.key}
                    value={values[field.key] ?? ''}
                    onChange={(value) => onValuesChange({ ...values, [field.key]: value })}
                />
            ))}
        </div>
    </div>
);

export default SchemaFieldsEditor;
